
const digest = '7a3b5df0f36bed0d9cd1ba1c4de1afb4145e7256158c6ce28c48a9fee5de2942';
const classes = {"wrapper":"_wrapper_l7g4r_1"};
const css = `._wrapper_l7g4r_1 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  